import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t("contact.errorName");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) e.email = t("contact.errorEmail");
    if (!values.message.trim() || values.message.trim().length < 4) e.message = t("contact.errorMessage");
    return e;
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    const eObj = validate();
    setErrors(eObj);
    if (Object.keys(eObj).length > 0) return;
    setSubmitting(true);
    setTimeout(() => {
      navigate("/thank_you");
    }, 400);
  };

  const setField = (k) => (ev) => setValues((v) => ({ ...v, [k]: ev.target.value }));

  return (
    <form className="contact-form" onSubmit={onSubmit} noValidate data-testid="contact-form">
      <div className="field">
        <label htmlFor="cf-name" className="field-label">{t("contact.nameLabel")}</label>
        <input
          id="cf-name"
          type="text"
          className={`field-input ${errors.name ? "field-input-error" : ""}`}
          value={values.name}
          onChange={setField("name")}
          placeholder={t("contact.namePlaceholder")}
          data-testid="cf-name"
          autoComplete="name"
        />
        {errors.name && <span className="field-error">{errors.name}</span>}
      </div>

      <div className="field">
        <label htmlFor="cf-email" className="field-label">{t("contact.emailLabel")}</label>
        <input
          id="cf-email"
          type="email"
          className={`field-input ${errors.email ? "field-input-error" : ""}`}
          value={values.email}
          onChange={setField("email")}
          placeholder={t("contact.emailPlaceholder")}
          data-testid="cf-email"
          autoComplete="email"
        />
        {errors.email && <span className="field-error">{errors.email}</span>}
      </div>

      <div className="field">
        <label htmlFor="cf-message" className="field-label">{t("contact.messageLabel")}</label>
        <textarea
          id="cf-message"
          rows={5}
          className={`field-input field-textarea ${errors.message ? "field-input-error" : ""}`}
          value={values.message}
          onChange={setField("message")}
          placeholder={t("contact.messagePlaceholder")}
          data-testid="cf-message"
        />
        {errors.message && <span className="field-error">{errors.message}</span>}
      </div>

      <button type="submit" className="btn btn-solid btn-full" disabled={submitting} data-testid="cf-submit">
        {submitting ? t("contact.submitting") : t("contact.submit")}
      </button>
    </form>
  );
}
